var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAircon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "aircon_svg__svg-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.003 17.837v44.332m-7.327-41.132l7.338 7.056 7.338-7.056m-.028 37.13l-7.338-7.056-7.338 7.056m19.767-34.195l-2.438 9.884 9.776 2.828M27.585 55.226l2.444-9.883-9.782-2.828m.011-5.854l9.782-2.828-2.444-9.883m32.146 18.587l-9.782 2.828 2.444 9.884M59.2 28.917L20.811 51.083m0-22.166L59.2 51.083",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgODAgODAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBkPSJNNDAuMDAyOSAxNy44MzY4VjYyLjE2OU0zMi42NzYyIDIxLjAzNzJMNDAuMDE0MSAyOC4wOTI5TDQ3LjM1MiAyMS4wMzcyTTQ3LjMyMzkgNTguMTY3TDM5Ljk4NiA1MS4xMTEzTDMyLjY0ODEgNTguMTY3TTUyLjQxNTIgMjMuOTcyM0w0OS45NzY4IDMzLjg1NTlMNTkuNzUzMSAzNi42ODM4TTI3LjU4NSA1NS4yMjYyTDMwLjAyOTEgNDUuMzQyNkwyMC4yNDcxIDQyLjUxNDdNMjAuMjU4MiAzNi42NjEyTDMwLjA0MDIgMzMuODMzM0wyNy41OTYxIDIzLjk0OTdNNTkuNzQxOCA0Mi41MzczTDQ5Ljk1OTggNDUuMzY1Mkw1Mi40MDM5IDU1LjI0ODhNNTkuMiAyOC45MTY5TDIwLjgxMTUgNTEuMDgzTTIwLjgxMTUgMjguOTE2OUw1OS4yIDUxLjA4MyIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz48L3N2Zz4=";
export { SvgAircon as ReactComponent };